import * as actionTypes from '../actions';

const initialState = {
    coverPage: {
        preparedFor: {
            label: "Prepared For:",
            value: "",
            invalid: false
        },
        preparedBy:{
            label: "Prepared By:",
            value: "",
            invalid: false
        },
        firm: ""
    }
};

let updateCoverPage = (state, key, value) => {
    let newState = Object.assign({}, state);
    newState.coverPage = {
        preparedFor: {
            label: "Prepared For:",
            value: state.coverPage.preparedFor.value,
            invalid: state.coverPage.preparedFor.invalid
        },
        preparedBy: {
            label: "Prepared By:",
            value: state.coverPage.preparedBy.value,
            invalid: state.coverPage.preparedBy.invalid
        },
        firm: newState.firm
    };

    newState.coverPage[key].value = value;

    return newState;
};

const coverPageReducer = (state = initialState, action) => {

    if (action.type === actionTypes.UPDATE_COVER_PAGE) {
        return updateCoverPage(state, action.key, action.value);
    }

    return state;
};

export default coverPageReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/coverPage.js